import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import FormInputText from '../../_shared/forms/FormInputText';
import DatePicker from 'react-datepicker';
import JobExtras from '../JobExtras';
import FormMultiSelect from '../../_shared/forms/FormMultiSelect';
import { snakeCaseToTitle } from '../../../utils/Helpers';
import moment from 'moment';
import SubmitButton from '../../_shared/SubmitButton';
import DtnService from '../../../services/DtnService';
import FormError from '../../_shared/forms/FormError';
import DtnPhotos from './paritals/DtnPhotos';
import DriverSignature from './paritals/DriverSignature';
import PricingDetails from './paritals/PricingDetails';
import EditVolumeJobs from './EditVolumeJobs';
import StatusButtons from './paritals/StatusButtons';

class EditWasteBag extends Component {
    constructor(props) {
        super(props);

        let { job, dtn, type } = this.props;

        let collectionDate = dtn.collection_date ? new Date(dtn.collection_date) : '';
        let beforeLoadingWaste = type.before_loading_waste ? new Date(type.before_loading_waste) : '';
        let afterLoadingWaste = type.after_loading_waste ? new Date(type.after_loading_waste) : '';
        let jobNotes = dtn.job_notes !== 'no' ? dtn.job_notes : '';

        this.state = {
            address: job.address_line_1 || '',
            postcode: job.postcode || '',
            collection_date: collectionDate,
            before_loading_waste: beforeLoadingWaste,
            after_loading_waste: afterLoadingWaste,
            job_notes: jobNotes || '',
            waste_collected: type.waste_collected,
            waste_contained: type.waste_contained,
            waste_description: type.waste_description,
            waste_volume: type.waste_volume,
            extrasOptions: this.props.jobExtras || '',
            wasteBagExtrasOptions: this.props.wasteBagExtras,
            selectedExtras: job.job_extras || '',
            selectedWasteBagExtras: job.waste_bag_extras,
            jobTypePrice: 0,
            totalPrice: 0,
            loading: false,
            images_before: '',
            images_after: '',
            van_images_before: '',
            van_images_after: '',
            customer_signature: '',
            rejected_files: {},
            errors: {},
            provider_quantity: job.provider_quantity,
        };
        this.dtnService = new DtnService();
    }

    componentDidMount() {
        let jobTypePrice = this.setJobTypePrice();
        this.calculateTotalPrice(jobTypePrice);
    }

    handleDateChange = (date, name) => {
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];
        this.setState({ [name]: date, errors: errorsObject });
    };

    handleChange = (e) => {
        let { name, value, type } = e.target;

        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];

        if (type === 'checkbox') value = this.state[name] === 'yes' ? 'no' : 'yes';

        this.setState({
            [name]: value,
            errors: errorsObject,
        });
    };

    setJobTypePrice = () => {
        let jobType = this.props.jobTypes.find((jobType) => {
            return jobType.id === this.props.job.job_type_id;
        });

        let jobTypePrice = jobType.pivot.price;

        this.setState({
            jobTypePrice: jobTypePrice,
        });

        return jobTypePrice;
    };

    calculateTotalPrice = (jobTypePrice) => {
        let totalPrice = jobTypePrice;

        if (this.state.selectedExtras) {
            this.state.selectedExtras.map((extra) => {
                totalPrice += extra.price * (extra.quantity ? extra.quantity : 1);
            });
        }

        if (this.state.selectedWasteBagExtras) {
            this.state.selectedWasteBagExtras.map((extra) => {
                totalPrice += extra.price * (extra.quantity ? extra.quantity : 1);
            });
        }

        this.setState({
            totalPrice: totalPrice / 100,
        });
    };

    handleMultiSelectChange = (value, type) => {
        let extras = [];

        if (value !== null && typeof value !== 'undefined' && value.length > 0) {
            extras = [...value];

            if (!extras[extras.length - 1].hasOwnProperty('quantity')) {
                extras[extras.length - 1].quantity = 1;
            }
        }
        this.setState(
            {
                [type]: extras,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice);
            }
        );
    };

    handleExtraQtyChange = (e, extra, type) => {
        let extras = [...this.state[type]];

        let extraIndex = extras.findIndex((ex) => ex.value === extra.value);

        extras[extraIndex].quantity = e.target.value;

        if (extra.singular) {
            extras[extraIndex].quantity = e.target.value;
        }

        this.setState(
            {
                [type]: extras,
            },
            () => {
                this.calculateTotalPrice(this.state.jobTypePrice);
            }
        );
    };

    onDrop = (acceptedFiles, name) => {
        let oldFiles = [...this.state[name]];
        let files = oldFiles.concat(acceptedFiles);

        this.setState({
            [name]: files,
        });
    };

    removeFile = (file, index, name) => {
        let acceptedFiles = [...this.state[name]];
        acceptedFiles.splice(index, 1);
        this.setState({
            [name]: acceptedFiles,
        });
    };

    onDropReject = (rejectedFiles, name) => {
        this.setState({
            rejectedFiles: { [name]: 'Photo size should be less than 2mb' },
        });
    };

    removeExistingMedia = (imageId) => {
        window.swal
            .fire({
                title: `Delete photo?`,
                text: `Are you sure you want to delete photo??`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: `Delete`,
            })
            .then((isConfirm) => {
                if (isConfirm.dismiss) return;

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },
                    url: `/jobs/${this.props.job.id}/dtn/media/${imageId}`,
                    dataType: 'json',
                    type: 'delete',
                    success: () => {
                        location.reload();
                    },
                });
            });
    };

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({ errors: {} });

        this.onSubmitValidate(e);
    };

    onSubmitValidate = (e) => {
        if (this.validateForm()) {
            //  Start spinner flag
            this.setState({ loading: true });

            const formData = this.mapInputsToFormData();

            formData.append('_method', 'PATCH');
            this.dtnService
                .updateDtn(this.props.job.id, formData)
                .then((res) => {
                    //  Stop spinner flag
                    this.setState({ loading: false });
                    toastr.success('Wtn was successfully edited');
                    window.location.reload();
                })
                .catch(() => {
                    //  Stop spinner flag
                    this.setState({ loading: false });
                    toastr.error('There was a problem while submitting the form. Please try again.');
                });
        }
    };

    validateForm = () => {
        let errors = {};
        const fields = [
            'address',
            'postcode',
            'collection_date',
            'before_loading_waste',
            'after_loading_waste',
            'waste_contained',
            'waste_collected',
            'waste_description',
            'waste_volume',
        ];

        fields.map((field) => {
            if (!this.state[field] || this.state[field] === undefined) {
                errors[field] = `${snakeCaseToTitle(field)} field is required`;
            }
        });

        this.setState({ errors: errors });
        return Object.keys(errors).length === 0;
    };

    mapInputsToFormData = () => {
        let formData = new FormData();
        const mappable = [
            'address',
            'postcode',
            'collection_date',
            'before_loading_waste',
            'after_loading_waste',
            'waste_contained',
            'waste_collected',
            'waste_description',
            'waste_volume',
            'job_notes',
            'provider_quantity',
        ];

        formData.append('job_extras', JSON.stringify(this.state.selectedExtras));
        formData.append('waste_bag_extras', JSON.stringify(this.state.selectedWasteBagExtras));
        this.state.images_before
            ? this.state.images_before.forEach((image) => formData.append('images_before[]', image))
            : '';
        this.state.images_after
            ? this.state.images_after.forEach((image) => formData.append('images_after[]', image))
            : '';
        this.state.van_images_before
            ? this.state.van_images_before.forEach((image) => formData.append('van_images_before[]', image))
            : '';
        this.state.van_images_after
            ? this.state.van_images_after.forEach((image) => formData.append('van_images_after[]', image))
            : '';
        this.state.customer_signature ? formData.append('customer_signature', this.state.customer_signature[0]) : '';

        mappable.forEach((input) => {
            if (input === 'collection_date') {
                formData.append(input, this.state[input] ? moment(this.state[input]).format('YYYY/MM/DD HH:mm') : '');
                return;
            }
            if (input === 'before_loading_waste' || input === 'after_loading_waste') {
                formData.append(input, this.state[input] ? moment(this.state[input]).format('HH:mm') : '');
                return;
            }
            formData.append(input, this.state[input]);
        });

        return formData;
    };

    render() {
        return (
            <Fragment>
                <form onSubmit={this.onSubmit} className="transform-text">
                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Job Details</h6>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-4">
                            <FormInputText
                                type="text"
                                name="address"
                                label="Address line 1"
                                value={this.state.address}
                                classes={this.state.errors.address ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.address}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <FormInputText
                                type="text"
                                name="postcode"
                                label="Postcode"
                                value={this.state.postcode}
                                classes={this.state.errors.postcode ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.postcode}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-4">
                            <label>Collection date</label>
                            <DatePicker
                                className={
                                    this.state.errors.collection_date ? 'form-control is-invalid' : 'form-control'
                                }
                                placeholderText="collection date"
                                selected={this.state.collection_date || null}
                                onChange={(date) => this.handleDateChange(date, 'collection_date')}
                                dateFormat="dd/MM/yyyy"
                            />
                            <FormError error={this.state.errors.collection_date} />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Time before loading the waste</label>
                            <DatePicker
                                className={
                                    this.state.errors.before_loading_waste ? 'form-control is-invalid' : 'form-control'
                                }
                                placeholderText="time before loading the waste"
                                selected={this.state.before_loading_waste || null}
                                onChange={(date) => this.handleDateChange(date, 'before_loading_waste')}
                                dateFormat="HH:mm"
                                timeIntervals={15}
                                showTimeSelect
                                showTimeSelectOnly
                            />
                            <FormError error={this.state.errors.before_loading_waste} />
                        </div>
                        <div className="form-group col-md-4">
                            <label>Time after loading the waste</label>
                            <DatePicker
                                className={
                                    this.state.errors.after_loading_waste ? 'form-control is-invalid' : 'form-control'
                                }
                                placholderText="time after loading the waste"
                                selected={this.state.after_loading_waste || null}
                                onChange={(date) => this.handleDateChange(date, 'after_loading_waste')}
                                dateFormat="HH:mm"
                                timeIntervals={15}
                                showTimeSelect
                                showTimeSelectOnly
                            />
                            <FormError error={this.state.errors.after_loading_waste} />
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                label="Provider quantity"
                                name="provider_quantity"
                                step="1"
                                min="0"
                                classes="form-control"
                                value={this.state.provider_quantity}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Job notes</label>
                            <textarea
                                className="form-control"
                                name="job_notes"
                                id="job_notes"
                                value={this.state.job_notes}
                                onChange={this.handleChange}
                                placeholder="Job notes..."
                                rows="5"
                            ></textarea>
                        </div>
                    </div>

                    <div className="row pb-3">
                        <div className="col-12">
                            <h6 className="py-2 pl-2 cw-bg-grey text-white">Waste collected</h6>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_contained"
                                label="How was the waste contained:"
                                value={this.state.waste_contained}
                                classes={this.state.errors.waste_contained ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.waste_contained}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_description"
                                label="Description of the waste being collected:"
                                value={this.state.waste_description}
                                classes={
                                    this.state.errors.waste_description ? 'form-control is-invalid' : 'form-control'
                                }
                                error={this.state.errors.waste_description}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_collected"
                                label="Estimated weight of waste collected(Kg):"
                                value={this.state.waste_collected}
                                classes={this.state.errors.waste_collected ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.waste_collected}
                                handleChange={this.handleChange}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <FormInputText
                                type="text"
                                name="waste_volume"
                                label="Total waste collected(CY):"
                                value={this.state.waste_volume}
                                classes={this.state.errors.waste_volume ? 'form-control is-invalid' : 'form-control'}
                                error={this.state.errors.waste_volume}
                                handleChange={this.handleChange}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group col-md-6">
                            <FormMultiSelect
                                label="Job Extras"
                                options={this.state.extrasOptions}
                                handleMultiSelectChange={(value) =>
                                    this.handleMultiSelectChange(value, 'selectedExtras')
                                }
                                classes="form-control"
                                prefixes={this.state.selectedExtras}
                            />
                        </div>
                        <div className="form-group col-md-6">
                            <FormMultiSelect
                                label="Waste Bag Extras"
                                options={this.state.wasteBagExtrasOptions}
                                handleMultiSelectChange={(value) =>
                                    this.handleMultiSelectChange(value, 'selectedWasteBagExtras')
                                }
                                classes="form-control"
                                prefixes={this.state.selectedWasteBagExtras}
                            />
                        </div>
                    </div>

                    <JobExtras
                        extras={this.state.selectedExtras}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        extrasType="selectedExtras"
                        extrasPrices={this.props.jobExtras}
                        dtn={true}
                    />

                    <JobExtras
                        extras={this.state.selectedWasteBagExtras}
                        onExtraQtyChange={this.handleExtraQtyChange}
                        extrasType="selectedWasteBagExtras"
                        extrasPrices={this.props.wasteBagExtras}
                        dtn={true}
                    />

                    <PricingDetails
                        totalPrice={this.state.totalPrice}
                        timeSpentWorking={this.props.timeSpentWorking}
                        laborCost={this.props.laborCost}
                    />

                    <DtnPhotos
                        title="Photos before clearing"
                        name="images_before"
                        acceptedFiles={this.state.images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.images_before}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Photos after clearing"
                        name="images_after"
                        acceptedFiles={this.state.images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.images_after}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Van photos before clearing"
                        name="van_images_before"
                        acceptedFiles={this.state.van_images_before}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.van_images_before}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DtnPhotos
                        title="Van photos after clearing"
                        name="van_images_after"
                        acceptedFiles={this.state.van_images_after}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.van_images_after}
                        multiple={true}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <DriverSignature imagePath={this.props.signaturePath} />

                    <DtnPhotos
                        title="Customer signature"
                        name="customer_signature"
                        acceptedFiles={this.state.customer_signature}
                        onDrop={this.onDrop}
                        removeFile={this.removeFile}
                        media={this.props.media.customer_signature}
                        multiple={false}
                        removeExistingMedia={this.removeExistingMedia}
                        onDropReject={this.onDropReject}
                        rejectedFiles={this.state.rejectedFiles}
                        jobId={this.props.job.id}
                    />

                    <SubmitButton
                        buttonText="Edit WTN"
                        loading={this.state.loading}
                        style={{ width: 200, marginTop: 20 }}
                    />
                    <StatusButtons jobId={this.props.job.id} style={{ marginTop: 20 }} />
                    <a
                        href={this.props.downloadUrl}
                        className="btn btn-cw-green"
                        style={{ width: 200, marginTop: 50, marginLeft: 15 }}
                    >
                        Download WTN
                    </a>
                </form>

                <div className="row">
                    <div className="col-md-6 text-left">
                        {this.props.job.status === 'done' && this.props.previousJob ? (
                            <a href={this.props.previousJob}>Previous job</a>
                        ) : (
                            ''
                        )}
                    </div>
                    <div className="col-md-6 text-right">
                        {this.props.job.status === 'done' && this.props.nextJob ? (
                            <a href={this.props.nextJob}>Next job</a>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </Fragment>
        );
    }
}

if (document.getElementById('edit-waste-bag')) {
    let element = document.getElementById('edit-waste-bag');
    ReactDOM.render(
        <EditWasteBag
            job={JSON.parse(element.dataset.job)}
            dtn={JSON.parse(element.dataset.dtn)}
            type={JSON.parse(element.dataset.type)}
            jobExtras={JSON.parse(element.dataset.job_extras)}
            wasteBagExtras={JSON.parse(element.dataset.waste_bag_extras)}
            media={JSON.parse(element.dataset.media)}
            signaturePath={element.dataset.signature_path}
            jobTypes={JSON.parse(element.dataset.job_types)}
            timeSpentWorking={element.dataset.time_spent_working}
            laborCost={element.dataset.labor_cost}
            downloadUrl={element.dataset.download_url}
        />,
        element
    );
}

export default EditWasteBag;
